import { render, staticRenderFns } from "./SubEmpresaTabelaGestao.vue?vue&type=template&id=4cdc091c&lang=pug"
import script from "./SubEmpresaTabelaGestao.vue?vue&type=script&lang=js"
export * from "./SubEmpresaTabelaGestao.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaTabelaGestao.vue?vue&type=style&index=0&id=4cdc091c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports